import {AutoComplete, Divider, Select, Space} from "antd";
import {Button, Col, Input, Row, Typography} from "antd";
import logo from "../Assets/logo.png";
import {useEffect, useState} from "react";
import {getOptions} from "../Utils/api";
import {useNavigate} from "react-router-dom";


export const KBSearch = () => {
  const { Search } = Input
  const searchEntities = ['Drugs', 'Diseases', 'AlternateMedicine', 'Genes', 'miRNAs', 'lncRNAs', 'PDBs', 'Drug-Disease', 'Disease-Gene', 'Disease-miRNA', 'Disease-lncRNA', 'Drug-PDB']

  const [selectedEntity, setSelectedEntity] = useState('Drugs')
  const [searchedEntity, setSearchedEntity] = useState('')
  const [options, setOptions] = useState([])

  let navigate = useNavigate()

  const onSearch = value => getOptions(selectedEntity, value)
    .then(r => setOptions(r.data))
    .catch(e => console.log(e))

  return(
    <div className="div-primary-color" style={{ padding: 10 }}>
      <Row align="middle" justify="center">
        <Col>
          <img width={150} src={logo} alt="HBKU Logo" />
        </Col>
        <Col>
          <div style={{ textAlign: 'center', marginLeft: 10 }}>
            <Typography.Title>COVID-19Base 3.0</Typography.Title>
            <Typography.Title level={4}>A Comprehensive Knowledgebase for Coronaviruses</Typography.Title>
            <Space>
              <Select dropdownMatchSelectWidth={200} onChange={r => setSelectedEntity(r)} defaultValue="Drugs" size="large">
                {searchEntities.map(v => <Select.Option value={v} key={v}>{v}</Select.Option>)}
              </Select>
              <AutoComplete
                size="large"
                onSearch={onSearch}
                options={options}
                onSelect={v => navigate(`/${selectedEntity.toLowerCase()}/${v}`, { replace: true })}
              >
                <Search
                  placeholder="input search text"
                  allowClear
                  size="large"
                  // onSearch={v => navigate(`/${selectedEntity.toLowerCase()}/${v}`, { replace: true })}
                />
              </AutoComplete>
            </Space>
            <p>
              <span style={{ fontWeight: 'bold' }}>Example:</span> <Button onClick={() => navigate(`/diseases/COVID-19`, { replace: true })} style={{ color: '#fff', fontWeight: 'bold' }} type="link">COVID-19</Button>
            </p>
          </div>
        </Col>
      </Row>
      <Row justify="center">
      </Row>
    </div>
  )

  return(
    <div className="div-primary-color" style={{ padding: 10 }}>
      <div className="container">
        <Row>
          <Col span={24}>
            <div style={{ float: 'left', marginRight: '40px', marginLeft: '40px' }}>
              <img width={100} src={logo} alt="HBKU Logo" />
            </div>
            <Typography.Title style={{ fontSize: '40px', paddingBottom: '2px', marginBottom: 0 }}>COVID-19 Base v3.0</Typography.Title>
            <Typography.Title style={{ color: '#fff', paddingTop: '2px', fontSize: '30px', marginTop: 0 }}>A Comprehensive Knowledge base for Coronaviruses</Typography.Title>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={24}>
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <Space>
                <Select dropdownMatchSelectWidth={200} onChange={r => setSelectedEntity(r)} defaultValue="Drugs" size="large">
                  {searchEntities.map(v => <Select.Option value={v} key={v}>{v}</Select.Option>)}
                </Select>
                <AutoComplete
                  style={{ minWidth: '400px' }}
                  size="large"
                  onSearch={onSearch}
                  options={options}
                  onSelect={v => navigate(`/${selectedEntity.toLowerCase()}/${v}`, { replace: true })}
                >
                  <Search
                    placeholder="input search text"
                    allowClear
                    size="large"
                    // onSearch={v => navigate(`/${selectedEntity.toLowerCase()}/${v}`, { replace: true })}
                  />
                </AutoComplete>
              </Space>
              <div><span style={{ fontWeight: 'bold' }}>Example:</span> <Button onClick={() => navigate(`/diseases/COVID-19`, { replace: true })} style={{ color: '#fff', fontWeight: 'bold' }} type="link">COVID-19</Button></div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}